import {
  BodyText,
  Button,
  Flex,
  Modal,
  ModalClose,
  ModalContent,
  ModalFooter,
  ModalRoot,
  ModalRootProps,
} from '@utilitywarehouse/hearth-react';
import SpotUnavailableLight from '@utilitywarehouse/hearth-svg-assets/lib/spot-unavailable-light.svg';

interface ChangeAppointmentErrorModalProps extends Pick<
  ModalRootProps,
  'open'
> {
  onClose: () => void;
  reloadAppointments: () => Promise<void>;
  onKeepAppointment?: () => void;
  loading?: boolean;
}

export const ChangeAppointmentErrorModal = ({
  open,
  onClose,
  reloadAppointments,
  onKeepAppointment,
  loading = false,
}: ChangeAppointmentErrorModalProps) => {
  const handleReloadAppointments = async () => {
    await reloadAppointments();
    onClose();
  };

  return (
    <ModalRoot open={open} onOpenChange={onClose}>
      <Modal
        hideCloseButton
        // prevents dismissing the modal by clicking outside or pressing escape
        onPointerDownOutside={(event) => event.preventDefault()}
        onEscapeKeyDown={(event) => event.preventDefault()}
        onInteractOutside={(event) => event.preventDefault()}
        heading="There's been a problem reserving your appointment"
        image={
          <img
            src={SpotUnavailableLight}
            alt="A warning sign indicating the appointment could not be reserved"
            height={114}
            width={80}
          />
        }
      >
        <ModalContent>
          <Flex direction="column" gap="300">
            <BodyText textAlign="center">
              This could be because another customer beat you to it, or
              there&apos;s been a temporary system hiccup.
            </BodyText>
            <BodyText textAlign="center">
              Please hit &apos;Reload appointments&apos; to try again. Or, if
              you&apos;d like to keep your original appointment, just choose
              &apos;Keep appointment&apos;.
            </BodyText>
          </Flex>
        </ModalContent>
        <ModalFooter>
          <ModalClose>
            <Button
              type="button"
              colorScheme="functional"
              variant="ghost"
              disabled={loading}
              onClick={onKeepAppointment}
            >
              Keep appointment
            </Button>
          </ModalClose>
          <Button
            type="button"
            colorScheme="highlight"
            variant="solid"
            loading={loading}
            disabled={loading}
            onClick={handleReloadAppointments}
          >
            Reload appointments
          </Button>
        </ModalFooter>
      </Modal>
    </ModalRoot>
  );
};
